module.exports = __webpack_public_path__ + "img/other-logo-grand.98373ea9.png";